import { render, staticRenderFns } from "./Footer.vue.js?vue&type=template&id=1354e38e&scoped=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Footer.vue?vue&type=template&id=1354e38e&scoped=true"
import script from "./Footer.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Footer.vue?vue&type=script&lang=js"
import style0 from "./Footer.vue.scss?vue&type=style&index=0&id=1354e38e&prod&lang=scss&scoped=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Footer.vue?vue&type=style&index=0&id=1354e38e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1354e38e",
  null
  
)

export default component.exports